import {useCallback,useEffect,useRef,useState} from 'react';
import {crmAPI,apiError,useCRMAuth} from '../../crm/context/CRMAuthContext';
import {watchLiveRefresh} from '../../hooks/liveRefresh';

export const managerAPI={get:(path,config)=>crmAPI.get(`/manager${path}`,config),post:(path,data,config)=>crmAPI.post(`/manager${path}`,data,config),put:(path,data,config)=>crmAPI.put(`/manager${path}`,data,config),delete:(path,config)=>crmAPI.delete(`/manager${path}`,config)};
export const useManagerData=(path,params,enabled=true,pollInterval=10000)=>{
  const {user}=useCRMAuth();
  const identity=JSON.stringify([user?.id,user?.tenant_id,user?.role]);
  const [data,setData]=useState(null),[error,setError]=useState(''),[loading,setLoading]=useState(true);
  const current=useRef(null),pending=useRef(null);
  const query=JSON.stringify(params||{});
  const reload=useCallback(async(silent=false)=>{
    if(!enabled||!path){setLoading(false);return null;}
    const epoch=current.current;
    if(pending.current?.epoch===epoch)return pending.current.promise;
    if(!silent)setLoading(true);
    const request={epoch,controller:new AbortController()};
    request.promise=managerAPI.get(path,{params:JSON.parse(query),signal:request.controller.signal,timeout:20000})
      .then(response=>{if(current.current===epoch){setData(response.data);setError('');}return response.data;})
      .catch(e=>{if(current.current===epoch){setData(null);setError(apiError(e));}throw e;})
      .finally(()=>{if(current.current===epoch)setLoading(false);if(pending.current===request)pending.current=null;});
    pending.current=request;
    return request.promise;
  },[path,query,enabled,identity]);
  useEffect(()=>{
    const epoch={};current.current=epoch;
    setData(null);setError('');reload().catch(()=>{});
    const stop=enabled?watchLiveRefresh(()=>reload(true).catch(()=>{}),pollInterval):()=>{};
    return()=>{stop();current.current=null;pending.current?.controller.abort();pending.current=null;};
  },[reload,enabled,pollInterval]);
  return {data,error,loading,reload};
};